<template>
  <section>
    <TableListing :items="items" :fields="fieldsAll" :showPaginationRow="true" :pagination.sync="pagination" :options.sync="tableOptions">
      <template v-slot:cell(amount)="data">
        <span>$ {{ parseFloat(data.item.amount).toFixed(2) }}</span>
      </template>
      <template v-slot:cell(clientCode)="data">
        <span>{{ data.item.clientCode }} </span>
      </template><template v-slot:cell(unitPrice)="data">
        <span>
          $ {{ parseFloat( parseFloat(data.item.unitPrice) ).toFixed(2) }}
        </span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'OrderedStorefrontItemsReport-view',
  components: {
    TableListing: TableListing
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      myProjs: 'getMyProjects',
      countryCodeList: 'getCountryCodeList',
      USAStateCodeList: 'getUSAStateCodeList'
    })
  },
  mounted() {
    this.tableOptions.totalRows = this.items.length;
  },
  data() {
    return {
      pagination: {
        sortBy: '',
        sortDesc: false,
        perPage: 10,
        page: 1
      },
      tableOptions: {
        totalRows: 10,
        loadedAll: true
      },
      fieldsAll: [
        { key: 'clientCode', label: 'Storefront', sortable: true },
        { key: 'productItem', label: 'Product SKU', sortable: true },
        { key: 'productItemName', label: 'Name', sortable: true },
        { key: 'quantity', label: 'Quantity', sortable: true },
        { key: 'unitPrice', label: 'Unit Price', sortable: true }
      ],
    }
  }
}
</script>

<style>

</style>
